import { render, staticRenderFns } from "./selectProjectRoleDlg.vue?vue&type=template&id=b01d4bfc"
import script from "./selectProjectRoleDlg.vue?vue&type=script&lang=js"
export * from "./selectProjectRoleDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports